// myReactLib/BasicItems.js — small reusable building blocks for W4U.
//
// React refresher (the side you're less comfortable with):
//   - These are "function components": JS functions that return JSX.
//   - { children, href, ... } destructures the "props" the caller passed
//     (e.g. <OrangeButton href="...">text</OrangeButton>).
//   - `children` is whatever sits between the opening/closing tags.

import React from 'react';
import { Link } from 'react-router-dom';

/**
 * OrangeButton — the WorksForYou orange CTA.
 *   variant: 'default' (nav-sized) | 'hero' (bigger, with glow)
 *   Pick exactly one of these props:
 *     to="/path"             → renders <Link> (React Router, no page reload)
 *     href="https://..."     → renders <a>   (external/anchor link, full navigation)
 *     onClick={fn} (no to/href) → renders <button> (in-page action)
 */
const OrangeButton = ({ children, to, href, onClick, variant = 'default', style }) => {
  const className =
    'w4u-btn-orange' + (variant === 'hero' ? ' w4u-btn-orange--hero' : '');

  if (to) {
    return (
      <Link to={to} className={className} style={style} onClick={onClick}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={className} style={style} onClick={onClick}>
        {children}
      </a>
    );
  }
  return (
    <button type="button" className={className} style={style} onClick={onClick}>
      {children}
    </button>
  );
};

export { OrangeButton };
